import React from 'react'
import css from "../Modulecss/Home.module.css";
import { Link } from "react-router-dom";

export default function RunningCard({runnig,user,winnAmount,game_type}) {
    const beckendLocalApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
    const beckendLiveApiUrl = process.env.REACT_APP_BACKEND_LIVE_API;
    const publicLocalUrl = process.env.REACT_APP_BACKEND_LOCAL_URL;
    const publicLiveUrl = process.env.REACT_APP_BACKEND_LIVE_URL;
    var publicUrl;
    const nodeMode = process.env.NODE_ENV;
    if (nodeMode === "development") {
      var baseUrl = beckendLocalApiUrl;
      publicUrl = publicLocalUrl;
    } else {
      baseUrl = beckendLiveApiUrl;
      publicUrl = publicLiveUrl;
    }
  
    return (
        <div className={`${css.betCard} mt-1 card`} 
      >
            
                <div className={`${css.betcard_user_info}`}>
            
                    <div className={`${css.betCard_user_info}`}>
                       
                            PLAYING FOR
                       
                        <i className="fa-solid fa-indian-rupee-sign" style={{paddingLeft: '0.3rem'}}></i>
                        {runnig.Game_Ammount}
                       
                    </div>
                    <div className='mid'></div>
                    <div className={`${css.betCard_user_info}`}>
                            PRIZE
                            
                                <i className="fa-solid fa-indian-rupee-sign" style={{paddingLeft: '0.3rem'}}></i>
                        
                                {runnig.Game_Ammount +
                                    winnAmount(runnig.Game_Ammount)}
                            
                    </div>

                </div>


                <div 
                className={`${css.betcard_user_set}`}
                >
                    <div >
                        <div className='' style={{marginBottom: '0.5rem'}}>
                            {runnig?.creator?.avatar ? (<img
                                src={publicUrl+`${runnig.creator && runnig?.creator?.avatar}`} onError={(e)=>{e.target.onerror = null; e.target.src=process.env.PUBLIC_URL + '/user.png'}}
                                alt=""
                                width='35px' height="35px"
                                style={{ borderTopLeftRadius: "50%", borderTopRightRadius: "50%", borderBottomRightRadius: "50%", borderBottomLeftRadius: "50%",
                                }}
                            />) : (<img
                                src={process.env.PUBLIC_URL + '/user.png'}
                                alt=""
                                width='35px' height="35px"
                                style={{ borderTopLeftRadius: "50%", borderTopRightRadius: "50%", borderBottomRightRadius: "50%", borderBottomLeftRadius: "50%" }}
                            />)}
                        </div>
                        <div style={{ lineHeight: 1 }} className='text-center'>
                            <span className={css.betCard_playerName}>
                                {runnig?.creator?.Name}
                            </span>
                        </div>
                    </div>

                    <div className='mid'>
                        <div>
                            <img
                                src={process.env.PUBLIC_URL + '/Images/kd_ludo/versus.png'}
                                alt=""
                                width="60px"
                            />
                        </div>
                    </div>
                    
                    <div>
                        <div className='text-center' style={{marginBottom: '0.5rem'}}>
                            {runnig?.accepted_by?.avatar ? (<img
                                src={publicUrl+`${runnig.accepted_by && runnig?.accepted_by?.avatar}`} onError={(e)=>{e.target.onerror = null; e.target.src=process.env.PUBLIC_URL + '/user.png'}}
                                alt=""
                                width='35px' height="35px"
                                style={{ borderTopLeftRadius: "50%", borderTopRightRadius: "50%", borderBottomRightRadius: "50%", borderBottomLeftRadius: "50%" }}
                            />) : (<img
                                src={process.env.PUBLIC_URL + '/user.png'}
                                alt=""
                                width='35px' height="35px"
                                style={{ borderTopLeftRadius: "50%", borderTopRightRadius: "50%", borderBottomRightRadius: "50%", borderBottomLeftRadius: "50%" }}
                            />)}
                        </div>
                        <div style={{ lineHeight: 1 }}>
                            <span className={css.betCard_playerName}>
                                {runnig?.accepted_by?.Name}
                            </span>
                        </div>
                    </div>
                </div>

           
                {(user == runnig?.accepted_by?._id ||
                        user == runnig?.creator?._id) && (
                            <Link
                                className={`${css.betcardbtn} ${runnig.Status=="conflict"?'bg-danger':'bg-success'}`}
                            
                                to={{ pathname: `/viewgame1/${runnig._id}`, state: { prevPath: window.location.pathname } }}
                            >
                                View
                            </Link>
                )}
          
            </div>
       
    )
}